<template>
  <div class="app-container">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-content">
        <div class="logo">
          没有写的游戏私聊:<span @click="showLogin = true">群主</span>
        </div>
        <div class="user-actions">
          <!-- <el-button v-if="!token" round size="small" >登录</el-button> -->
          <!-- <el-button v-if="!token" round size="small" type="primary" @click="showReg = true">注册</el-button> -->
          <div v-if="token" class="user-info">
            <el-button round size="small" type="danger" @click="logout">退出</el-button>
          </div>
        </div>
      </div>
    </header>

    <!-- 主体内容 -->
    <main class="main-content">
      <!-- 公告卡片 - 仅管理员可见 -->
      <div v-if="token && notice" class="notice-card">
        <div class="notice-header">
          <i class="el-icon-bell"></i> 系统公告
        </div>
        <div class="notice-body">
          {{ notice.content }}
        </div>
        <div class="notice-footer">
          <el-button type="text" size="mini" @click="editNotice">编辑公告</el-button>
        </div>
      </div>

      <!-- 操作栏 -->
      <div v-if="token" class="action-bar">
        <div class="add-category-btn">
          <el-button type="primary" icon="el-icon-plus" size="medium" @click="openAddCateDialog">创建新分类</el-button>
        </div>
      </div>

      <!-- 分类列表 -->
      <div class="category-list">
        <div class="category-card" v-for="cate in list" :key="cate.id">
          <div class="card-header">
            <div class="cate-title">
              <span class="cate-icon">#</span>
              <span class="cate-name">{{ cate.name }}</span>
              <el-button v-if="token" type="text" size="small" icon="el-icon-edit" @click="openEditCateDialog(cate)" class="compact-btn">编辑</el-button>
            </div>
            <div class="cate-meta">
              <span class="update-time">更新于: {{ cate.update_time }}</span>
              <el-button v-if="token" size="mini" type="danger" icon="el-icon-delete" circle @click="delCate(cate.id)" class="compact-btn"></el-button>
            </div>
          </div>

          <div class="item-list">
            <div class="item-row" v-for="item in cate.items" :key="item.id">
              <div class="item-info">
                <div class="item-name">{{ item.name }}</div>
                <!-- 规格展示 -->
                <div class="item-specs">
                  <div v-if="item.specs && item.specs.length > 0" class="specs-list">
                    <span v-for="(spec, idx) in item.specs" :key="idx" class="spec-tag">
                      {{ spec.spec_name ? (spec.spec_name + '：') : spec.spec_name }}¥{{ formatAmount(spec.price) }}
                    </span>
                  </div>
                  <div v-else class="spec-tag no-price">暂无价格</div>
                </div>
              </div>
              <!-- 管理操作按钮 -->
              <div v-if="token" class="item-actions">
                <el-button size="mini" type="primary" plain icon="el-icon-edit" @click="openEditItemDialog(item)" class="compact-btn">编辑</el-button>
                <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="delItem(item.id)" class="compact-btn">删除</el-button>
              </div>
            </div>
          </div>

          <!-- 添加商品栏 -->
          <div v-if="token" class="add-item-row">
            <el-input v-model="newItem[cate.id]" placeholder="商品名称" size="small" clearable style="flex: 1;"></el-input>
            <el-button type="success" size="small" icon="el-icon-plus" @click="openAddItemDialog(cate.id)" class="compact-btn">添加商品</el-button>
          </div>
        </div>
      </div>
    </main>

    <!-- 弹窗：公告展示（未登录时） -->
    <el-dialog :visible.sync="showNoticeDialog" title="系统公告" width="380px" center>
      <div class="notice-dialog-content" v-if="notice">
        {{ notice.content }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showNoticeDialog = false" size="small">我知道了</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗：登录/注册 -->
    <el-dialog :visible.sync="showLogin" title="用户登录" width="350px" center>
      <el-input v-model="loginForm.username" placeholder="用户名" prefix-icon="el-icon-user" style="margin-bottom:18px"></el-input>
      <el-input v-model="loginForm.password" placeholder="密码" type="password" prefix-icon="el-icon-lock" @keyup.enter.native="doLogin"></el-input>
      <el-button type="primary" style="width:100%; margin-top: 20px;" @click="doLogin">登 录</el-button>
    </el-dialog>

    <el-dialog :visible.sync="showReg" title="用户注册" width="350px" center>
      <el-input v-model="regForm.username" placeholder="设置用户名" prefix-icon="el-icon-user" style="margin-bottom:18px"></el-input>
      <el-input v-model="regForm.password" placeholder="设置密码" type="password" prefix-icon="el-icon-lock" @keyup.enter.native="doReg"></el-input>
      <el-button type="success" style="width:100%; margin-top: 20px;" @click="doReg">注 册</el-button>
    </el-dialog>

    <!-- 弹窗：编辑公告 -->
    <el-dialog :visible.sync="showNoticeEdit" title="编辑公告" width="450px">
      <el-input type="textarea" :rows="4" v-model="noticeForm.content" placeholder="请输入公告内容" resize="none"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showNoticeEdit = false" size="small">取消</el-button>
        <el-button type="primary" @click="saveNotice" size="small">保存</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗：新增分类 -->
    <el-dialog :visible.sync="showAddCateDialog" title="新增分类" width="350px">
      <el-input v-model="addCateForm.name" placeholder="请输入分类名称" clearable autofocus></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddCateDialog = false" size="small">取消</el-button>
        <el-button type="primary" @click="submitAddCate" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗：编辑分类 -->
    <el-dialog :visible.sync="showEditCateDialog" title="编辑分类" width="350px">
      <el-input v-model="editCateForm.name" placeholder="分类名称" clearable></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditCateDialog = false" size="small">取消</el-button>
        <el-button type="primary" @click="submitEditCate" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗：添加/编辑商品（支持多规格） -->
    <el-dialog :visible.sync="showAddEditItemDialog" :title="itemDialogTitle" width="80%">
      <el-form label-width="80px" size="small">
        <el-form-item label="商品名称" required>
          <el-input v-model="itemForm.name" placeholder="请输入商品名称" clearable></el-input>
        </el-form-item>
        
        <el-form-item label="规格设置">
          <div class="specs-editor">
            <div class="specs-header">
              <span class="specs-tip">💡 提示：如梨有水梨和干梨两种价格，可添加多个规格</span>
              <el-button type="primary" size="mini" plain icon="el-icon-plus" @click="addSpec">添加规格</el-button>
            </div>
            
            <div v-if="itemForm.specs.length === 0" class="spec-empty">
              <el-radio v-model="itemForm.hasSpecs" :label="false">无规格（单一价格）</el-radio>
            </div>
            
            <div v-else class="specs-list-editor">
              <div v-for="(spec, index) in itemForm.specs" :key="index" class="spec-item">
                <el-input 
                  v-model="spec.spec_name" 
                  placeholder="规格名称（如水梨）" 
                  size="small" 
                  style="width: 140px;"
                ></el-input>
                <el-input-number 
                  v-model="spec.price" 
                  :precision="2" 
                  :step="0.5" 
                  :min="0"
                  controls-position="right"
                  size="small"
                  style="width: 130px;"
                  placeholder="价格"
                ></el-input-number>
                <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="removeSpec(index)"></el-button>
              </div>
            </div>
            
            <div v-if="itemForm.specs.length === 0 && itemForm.hasSpecs === false" class="single-price-input">
              <el-input-number 
                v-model="itemForm.base_price" 
                :precision="2" 
                :step="0.5" 
                :min="0"
                controls-position="right"
                size="small"
                style="width: 100%;"
                placeholder="请输入价格"
              ></el-input-number>
            </div>
          </div>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddEditItemDialog = false" size="small">取消</el-button>
        <el-button type="primary" @click="submitItem" size="small">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

// 基础接口地址，后续只需修改这里即可
const baseUrl = 'api/api'
// const baseUrl = 'http://localhost:3000/api'

export default {
  data() {
    return {
      token: localStorage.getItem('token') || '',
      list: [],
      notice: null,
      noticeForm: { id: null, content: '' },
      showNoticeEdit: false,
      showNoticeDialog: false,
      
      showLogin: false,
      showReg: false,
      loginForm: { username: '', password: '' },
      regForm: { username: '', password: '' },
      
      newItem: {},
      newPrice: {},

      // 分类相关
      showAddCateDialog: false,
      addCateForm: { name: '' },
      showEditCateDialog: false,
      editCateForm: { id: null, name: '' },

      // 商品相关
      showAddEditItemDialog: false,
      itemDialogTitle: '添加商品',
      currentCateId: null,
      currentItemId: null,
      itemForm: {
        name: '',
        hasSpecs: false,
        specs: [],
        base_price: null
      }
    }
  },
  mounted() {
    this.getData()
    this.getNotice()
    // 未登录时弹公告（只弹一次）
    if (!this.token && this.notice && this.notice.content) {
      this.showNoticeDialog = true
    }
  },
  watch: {
    notice: {
      handler(newNotice) {
        // 未登录且首次加载公告时弹窗
        if (!this.token && newNotice && newNotice.content && !this._noticeShown) {
          this.showNoticeDialog = true
          this._noticeShown = true
        }
      },
      immediate: true
    }
  },
  methods: {
    formatAmount(num) {
      if (!num && num !== 0) return '';
      
      // 1. 四舍五入保留两位小数
      let fixedNum = Number(num).toFixed(2);
      
      // 2. 转数字自动去掉末尾的 0 和小数点
      return Number(fixedNum);
    },
    // --- 数据获取 ---
    async getData() {
      try {
        const res = await axios.get(`${baseUrl}/all`)
        if (res.data.code === 200) this.list = res.data.data || []
      } catch (err) {
        this.$message.error('获取数据失败，请检查后端服务')
      }
    },
    async getNotice() {
      try {
        const res = await axios.get(`${baseUrl}/notice`)
        if (res.data.code === 200) {
          this.notice = res.data.data
        }
      } catch (err) {
        console.error('获取公告失败', err)
      }
    },

    // --- 用户操作 ---
    async doLogin() {
      try {
        const res = await axios.post(`${baseUrl}/login`, this.loginForm)
        if (res.data.code === 200) {
          this.token = res.data.token
          localStorage.setItem('token', res.data.token)
          this.showLogin = false
          this.$message.success('欢迎回来！')
          this.getData()
          this.getNotice()
        } else {
          this.$message.error(res.data.msg)
        }
      } catch (err) {
        this.$message.error('登录失败，请检查网络')
      }
    },
    async doReg() {
      try {
        const res = await axios.post(`${baseUrl}/reg`, this.regForm)
        if (res.data.code === 200) {
          this.$message.success('注册成功，请登录')
          this.showReg = false
        } else {
          this.$message.error(res.data.msg)
        }
      } catch (err) {
        this.$message.error('注册失败')
      }
    },
    logout() {
      this.token = ''
      localStorage.clear()
      this.$message.info('已安全退出')
      window.location.reload()
    },

    // --- 公告操作 ---
    editNotice() {
      this.noticeForm = { id: this.notice.id, content: this.notice.content }
      this.showNoticeEdit = true
    },
    async saveNotice() {
      try {
        await axios.post(`${baseUrl}/notice/edit`, this.noticeForm, { headers: { token: this.token } })
        this.$message.success('公告已更新')
        this.showNoticeEdit = false
        this.getNotice()
      } catch (err) {
        this.$message.error('更新公告失败')
      }
    },

    // --- 分类操作 ---
    openAddCateDialog() {
      this.addCateForm = { name: '' }
      this.showAddCateDialog = true
    },
    async submitAddCate() {
      if (!this.addCateForm.name.trim()) return this.$message.warning('请输入分类名称')
      try {
        await axios.post(`${baseUrl}/cate/add`, { name: this.addCateForm.name.trim() }, { headers: { token: this.token } })
        this.$message.success('分类添加成功')
        this.showAddCateDialog = false
        this.getData()
      } catch (err) {
        this.$message.error('添加失败')
      }
    },
    openEditCateDialog(cate) {
      this.editCateForm = { id: cate.id, name: cate.name }
      this.showEditCateDialog = true
    },
    async submitEditCate() {
      if (!this.editCateForm.name.trim()) return this.$message.warning('分类名称不能为空')
      try {
        await axios.post(`${baseUrl}/cate/edit`, { id: this.editCateForm.id, name: this.editCateForm.name }, { headers: { token: this.token } })
        this.$message.success('分类已更新')
        this.showEditCateDialog = false
        this.getData()
      } catch (err) {
        this.$message.error('编辑分类失败')
      }
    },
    async delCate(id) {
      this.$confirm('确定删除该分类及旗下所有商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await axios.post(`${baseUrl}/cate/del`, { id }, { headers: { token: this.token } })
          this.$message.success('删除成功')
          this.getData()
        } catch (err) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    
    // --- 商品操作（支持规格）---
    openAddItemDialog(cateId) {
      this.currentCateId = cateId
      this.currentItemId = null
      this.itemDialogTitle = '添加商品'
      this.itemForm = {
        name: '',
        hasSpecs: false,
        specs: [],
        base_price: null
      }
      this.showAddEditItemDialog = true
    },
    
    openEditItemDialog(item) {
      this.currentCateId = item.cate_id
      this.currentItemId = item.id
      this.itemDialogTitle = '编辑商品'
      this.itemForm = {
        name: item.name,
        hasSpecs: item.specs && item.specs.length > 0,
        specs: item.specs && item.specs.length > 0 ? [...item.specs] : [],
        base_price: item.base_price
      }
      // 清理无效的规格项（id字段不需要提交）
      this.itemForm.specs.forEach(spec => {
        delete spec.id
      })
      this.showAddEditItemDialog = true
    },
    
    addSpec() {
      this.itemForm.specs.push({ spec_name: '', price: null })
      this.itemForm.hasSpecs = true
    },
    
    removeSpec(index) {
      this.itemForm.specs.splice(index, 1)
      if (this.itemForm.specs.length === 0) {
        this.itemForm.hasSpecs = false
      }
    },
    
    async submitItem() {
      // 验证
      if (!this.itemForm.name || this.itemForm.name.trim() === '') {
        return this.$message.warning('请输入商品名称')
      }
      
      const hasSpecs = this.itemForm.specs.length > 0
      
      if (hasSpecs) {
        // 验证规格
        for (let i = 0; i < this.itemForm.specs.length; i++) {
          const spec = this.itemForm.specs[i]
          // if (!spec.spec_name || spec.spec_name.trim() === '') {
          //   return this.$message.warning(`请填写第${i+1}个规格的名称`)
          // }
          if (spec.price === null || spec.price === undefined || isNaN(spec.price)) {
            return this.$message.warning(`请填写第${i+1}个规格的价格`)
          }
          spec.spec_name = spec.spec_name.trim()
          spec.price = parseFloat(spec.price)
        }
      } else {
        // 无规格验证价格
        if (this.itemForm.base_price === null || this.itemForm.base_price === undefined || isNaN(this.itemForm.base_price)) {
          return this.$message.warning('请输入商品价格')
        }
      }
      
      const url = this.currentItemId 
        ? `${baseUrl}/item/edit`
        : `${baseUrl}/item/add`
      
      const payload = {
        name: this.itemForm.name.trim(),
        has_specs: hasSpecs,
        specs: hasSpecs ? this.itemForm.specs : [],
        base_price: hasSpecs ? null : parseFloat(this.itemForm.base_price)
      }
      
      if (this.currentItemId) {
        payload.id = this.currentItemId
      } else {
        payload.cate_id = this.currentCateId
      }
      
      try {
        await axios.post(url, payload, { headers: { token: this.token } })
        this.$message.success(this.currentItemId ? '商品更新成功' : '商品添加成功')
        this.showAddEditItemDialog = false
        this.getData()
      } catch (err) {
        this.$message.error(this.currentItemId ? '编辑失败' : '添加失败')
      }
    },
    
    async delItem(id) {
      this.$confirm('确定删除该商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await axios.post(`${baseUrl}/item/del`, { id }, { headers: { token: this.token } })
          this.$message.success('删除成功')
          this.getData()
        } catch (err) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  background: linear-gradient(to right, #f5e6ff, #e6e6ff);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  overflow-x: hidden;
  width: 100%;
}

/* 顶部导航 */
.header {
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  position: sticky;
  top: 0;
  z-index: 10;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.96);
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 12px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.logo {
  font-size: 1.35rem;
  font-weight: 600;
  background: linear-gradient(135deg, #1e2a3a 0%, #2c3e50 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo .icon {
  font-size: 1.6rem;
  background: none;
  color: #2c3e50;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-badge {
  background: #ecfdf5;
  color: #059669;
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 0.75rem;
  font-weight: 500;
}

/* 主内容区 */
.main-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 32px 24px;
  overflow-x: hidden;
  width: 100%;
}

/* 操作栏 */
.action-bar {
  margin-bottom: 28px;
  display: flex;
  justify-content: flex-end;
}

.add-category-btn .el-button {
  border-radius: 40px;
  padding: 10px 20px;
  font-weight: 500;
}

/* 公告卡片 */
.notice-card {
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  margin-bottom: 32px;
  border: 1px solid #edf2f7;
  overflow: hidden;
}

.notice-header {
  padding: 16px 24px 8px 24px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #f1f5f9;
}

.notice-body {
  padding: 16px 24px;
  color: #334155;
  line-height: 1.5;
  font-size: 0.9rem;
  background: #fafcff;
}

.notice-footer {
  padding: 8px 24px 16px 24px;
  text-align: right;
}

/* 分类列表 */
.category-list {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.category-card {
  background: #ffffff;
  border-radius: 28px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #eef2f6;
  overflow: hidden;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px 12px 20px;
  background: #fefefe;
  border-bottom: 1px solid #f0f4f9;
  flex-wrap: wrap;
  gap: 10px;
}

.cate-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #0f172a;
}

.cate-icon {
  background: #eef2ff;
  color: #3b82f6;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.cate-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #64748b;
  font-size: 0.7rem;
}

.update-time {
  font-size: 0.65rem;
  background: #f8fafc;
  padding: 3px 8px;
  border-radius: 40px;
}

/* 商品列表 */
.item-list {
  padding: 4px 12px;
}

.item-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 8px;
  border-bottom: 1px solid #f1f5f9;
  gap: 12px;
}

.item-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.item-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 6px;
  flex: 1;
}

/* 规格展示 */
.item-specs {
  margin-top: 4px;
}

.specs-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.spec-tag {
  font-weight: bold;
  font-size: 16px;
  background: #fef3c7;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  color: #334155;
  display: inline-block;
}

.spec-tag.no-price {
  background: #fef3c7;
  color: #d97706;
}

/* 添加商品栏 */
.add-item-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px 16px 16px;
  background: #fafdff;
  border-top: 1px solid #edf2f8;
}

.add-item-row .el-input {
  max-width: 240px;
}

/* 规格编辑器 */
.specs-editor {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px;
  background: #fafcff;
}

.specs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
}

.specs-tip {
  font-size: 0.7rem;
  color: #64748b;
}

.spec-empty {
  padding: 12px 0;
}

.specs-list-editor {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}

.spec-item {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.single-price-input {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

.item-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.compact-btn {
  padding: 5px 10px !important;
  font-size: 0.75rem !important;
}

/* 弹窗 */
.notice-dialog-content {
  padding: 8px 4px;
  line-height: 1.6;
  color: #334155;
  white-space: pre-wrap;
}

/* 响应式 */
@media (max-width: 768px) {
  .header-content {
    padding: 10px 16px;
  }
  .main-content {
    padding: 20px 12px;
  }
  .item-row {
    flex-direction: column;
  }
  .item-actions {
    width: 100%;
    justify-content: flex-end;
  }
  .spec-item {
    flex-direction: column;
    align-items: stretch;
  }
  .spec-item .el-input,
  .spec-item .el-input-number {
    width: 100% !important;
  }
  .add-item-row {
    flex-direction: column;
  }
  .add-item-row .el-input {
    max-width: 100%;
    width: 100%;
  }
  .action-bar {
    justify-content: center;
  }
  .add-category-btn {
    width: 100%;
  }
  .add-category-btn .el-button {
    width: 100%;
  }
}
</style>